<ng-template #dialogProximamente>
    <neo-acciones-dialog #accionesProximamente [dialogTittle]="tituloDialog">
        <p>{{descripcionDialog}}</p>
    </neo-acciones-dialog>
</ng-template>